/** 报名已截止且该用户入金期已结束时写 1，否则 0。供同页其它节点条件渲染。 */
export const NUP_ACTIVITY_ENDED_VAR = 'nupActivityEnded';
